module.exports = __webpack_public_path__ + "static/img/pay-ok.f6a08aa0.png";